import React, { useEffect, useState } from "react";

function pad(n) { return String(n).padStart(2, "0"); }

export default function Countdown({ endTime, className = "", testId = "auction-timer" }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const end = endTime ? new Date(endTime).getTime() : now;
  const diff = Math.max(0, end - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  const critical = diff > 0 && diff < 3600000; // under 1 hour
  const ended = diff === 0;

  if (ended) {
    return (
      <span data-testid={testId} className={`font-display text-zinc-500 uppercase tracking-widest text-sm ${className}`}>
        Ended
      </span>
    );
  }

  return (
    <span
      data-testid={testId}
      className={`font-display font-bold tabular-nums tracking-tight ${critical ? "text-red-500 timer-critical" : "text-white"} ${className}`}
    >
      {days > 0 ? `${days}d ` : ""}{pad(hours)}:{pad(minutes)}:{pad(seconds)}
    </span>
  );
}
